import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CopyRightFooter from '../../components/footer/CopyRightFooter';
import MainFooter from '../../components/footer/MainFooter';

export default function Page404() {
  const history = useHistory();

  useEffect(() => {
    const timeout = setTimeout(() => {
      history.push('/main');
    }, 10000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <body>
      <main>
        <article className="screen screen--message">
          <div className="message">
            <div className="message message__logo">
              <img src="images/logo--dark.svg" width="232" height="76" alt="JCG Management" />
            </div>

            <div className="message__title">
              <h1>404 Not Found</h1>
            </div>

            <div className="message__icon animation--wobble">
              <img src="images/alert.svg" alt="!" />
            </div>

            <div className="message__content">
              <p>お探しのページは一時的にアクセスが出来ない状況にあるか、移動もしくは削除された可能性があります。</p>
            </div>

            <button
              className="button button__primary c-mt56 c-mb88"
              onClick={() => {
                history.push('/main');
              }}
            >
              トップに戻る
            </button>
          </div>
        </article>
      </main>

      <footer>
        <CopyRightFooter />
        <MainFooter />
      </footer>

      <script></script>
    </body>
  );
}
